import {
    getProductMediaSources,
    Product,
    ProductCarousel,
    ProductDotsButton
} from "@/entities/product";
import {ThumbsCarousel} from "./ThumbsCarousel";
import {useProductMainCarousel} from "../model/hooks/useProductMainCarousel";
import {useModalStore} from "@/Stores/Site/Product";
import styles from "./ProductMainCarousel.module.scss";

type Props = {
    product: Product;
}

export const ProductMainCarousel = ({product}: Props) => {
    const media = getProductMediaSources(product.imgDetail);

    const openZoomImageModal = useModalStore(s => s.openZoomImageModal);

    const carousel = useProductMainCarousel();

    return (
        <div className={styles.carouselContainer}>
            <ThumbsCarousel
                media={media}
                selectedIndex={carousel.selectedIndex}
                carouselRef={carousel.thumbsRef}
                onSelect={carousel.onDotButtonClick}
                alt={`${product.h1} ${product.article}`}
                className={styles.thumbsCarousel}
                onPrevButtonClick={carousel.onPrevButtonClick}
                onNextButtonClick={carousel.onNextButtonClick}
                prevBtnDisabled={carousel.prevBtnDisabled}
                nextBtnDisabled={carousel.nextBtnDisabled}
            />
            <div className={styles.carouselOffset}></div>
            <ProductCarousel
                media={media}
                carouselRef={carousel.mainRef}
                onZoom={openZoomImageModal}
                alt={`${product.h1} ${product.article}`}
                className={styles.mainCarousel}
                sticker={product.sticker}
            />
            <ProductDotsButton
                dots={carousel.scrollSnaps}
                selectedIndex={carousel.selectedIndex}
                onDotClick={carousel.onDotButtonClick}
            />
        </div>
    );
}
